// 套餐购买
<template>
  <div class="tcgm width1394 d-flex d-flex-jc-c d-flex-fw-w">
    <div class="item" v-for="(item, index) in tcgmList" :key="index">
      <!-- <p class="title">
        {{ item.title }}
        <span>稳定时长－{{ item.day }}天</span>
      </p> -->
      <p class="price">
        <b>¥</b>
        {{ item.amount }}
      </p>
      <div class="count d-flex">
        <span>购买时长：</span>
        <span class="input d-flex">
          <i class="del" @click="inputChange(index, 'del')"></i>
          <input
            type="text"
            :value="item.count"
            @input="countChange($event, index)"
          />
          <i class="add" @click="inputChange(index, 'add')"></i>
        </span>
        <span>月</span>
      </div>
      <div class="count">
        <span>单价: {{ item.price }} 元/月</span>
        <dl class="d-flex d-flex-fw-w">
          <dd
            class="d-flex d-flex-aic"
            v-for="(che, cheIndex) in tcgmCity"
            :key="cheIndex"
            @change="checkChange(index, cheIndex)"
          >
            <input
              type="radio"
              :name="item.checkName"
              :id="`${item.checkName}_${cheIndex}`"
              :checked="cheIndex == item.check ? true : false"
            />
            <label :for="`${item.checkName}_${cheIndex}`">{{ che }}</label>
          </dd>
        </dl>
      </div>
      <p class="text1">质量度：优质</p>
      <p class="text1">支持类型：HTTP,SOCK5</p>
      <p class="text1">不限制使用次数</p>
      <a href="#">联系客服</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tcgmCity: [
        "成都",
        "福州",
        "广州",
        "杭州",
        "南昌",
        "南宁",
        "青岛",
        "上海",
        "深圳",
        "石家庄",
        "苏州",
        "天津",
        "武汉",
        "西安",
        "长沙",
      ],
      tcgmList: [
        {
          title: "套餐1",
          day: 1,
          price: 80,
          amount: 0.00,
          count: 1,
          checkName: "tc1",
          check: 0,
        },
      ],
    };
  },
  watch: {
    'tcgmList': {
      deep: true,
      handler: function (val) {
        for (let i in val) {
          if (val[i].count <= 0) {
            this.tcgmList[i].count = 1
          }
        }
      },
    },
  },
  mounted() {
    for (let i in this.tcgmList) {
      this.freshPrice(i)
    }
  },
  methods: {
    inputChange(index, attr) {
      let count = parseInt(this.tcgmList[index].count);
      if (isNaN(count) || count < 1) {
        count = 1
      }
      if (attr == "del") {
        if (count <= 0) return;
        this.tcgmList[index].count--;
      } else {
        this.tcgmList[index].count++;
      }
      this.freshPrice(index)
    },
    countChange(e, index) {
      this.tcgmList[index].count = e.target.value.replace(/[^\d]/g, "");
      if (this.tcgmList[index].count !== "") {
        this.tcgmList[index].count = parseInt(this.tcgmList[index].count);
      }
      this.freshPrice(index)
    },
    checkChange(index, cheIndex) {
      this.tcgmList[index].check = cheIndex;
      this.freshPrice(index)
    },
    freshPrice(index) {
      let count = this.tcgmList[index].count
      if (count <= 0) {
        count = 1
      }
      this.tcgmList[index].amount = (this.tcgmList[index].price * count).toFixed(2)
    },
  },
};
</script>

<style lang="less" scoped>
.tcgm {
  padding: 97px 0 66px;
  .item {
    width: 316px;
    height: 870px;
    border: 3px solid #f78834;
    border-radius: 16px;
    position: relative;
    transition: all 0.3s;
    .title {
      font-size: 24px;
      color: #000;
      font-weight: bold;
      margin: 26px 0 0 30px;
      span {
        font-weight: normal;
        margin-left: 16px;
        font-size: 18px;
      }
    }
    .price {
      margin: 20px 0 20px 39px;
      font-size: 40px;
      color: #000;
      font-weight: bold;
      b {
        font-size: 54px;
        font-weight: normal;
      }
    }
    .count {
      margin-left: 39px;
      margin-bottom: 26px;
      .input {
        i {
          background-size: 100% 100%;
          width: 30px;
          height: 24px;
          line-height: 24px;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
          &.del {
            margin-right: 1px;
            background: url("../../assets/images/del.png");
          }
          &.add {
            margin-left: 1px;
            background: url("../../assets/images/add.png");
          }
        }
        input {
          width: 88px;
          line-height: 24px;
          height: 24px;
          background: #f78834;
          border: none;
          color: #fff;
          text-align: center;
          outline: none;
        }
      }
    }
    .text1 {
      font-size: 18px;
      color: #000;
      margin-left: 39px;
    }
    dl {
      margin-top: 20px;
      dd {
        width: 50%;
        margin-bottom: 14px;
        input[type="radio"] {
          appearance: none;
          content: "";
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: 2px solid #f78834;
          border-radius: 50%;
          vertical-align: middle;
          position: relative;
        }
        input[type="radio"]:checked:before {
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          background-color: #f78834;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
        }
        label {
          margin: 0;
        }
      }
    }
    a {
      display: inline-block;
      width: 168px;
      line-height: 48px;
      background: #f78834;
      font-size: 20px;
      color: #fff;
      text-align: center;
      border-radius: 10px;
      position: absolute;
      bottom: 46px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    &:hover {
      box-shadow: 0 2px 20px 6px #fddec7;
    }
  }
}
@media (max-width: 1534px) {
  .tcgm {
    padding: 3% 0;
  }
  .tcgm .item {
    width: 24%;
  }
}
@media (max-width: 1480px) {
  .width1394 {
    width: 96%;
  }
  .tcgm .item .title,
  .tcgm .item .price,
  .tcgm .item .count {
    margin: 4% 0 0 6%;
  }
  .tcgm .item .text1 {
    margin-left: 6%;
  }
}
@media (max-width: 1200px) {
  .tcgm .item {
    width: 49%;
    height: 740px;
    margin-bottom: 2%;
  }
  .tcgm .item dl dd {
    width: 33.33%;
  }
}
@media (max-width: 768px) {
  .tcgm .item {
    width: 100%;
    height: 640px;
  }
  .tcgm .item .title {
    font-size: 20px;
  }
  .tcgm .item .title span,
  .tcgm .item .text1,
  .count span,
  .tcgm .item dl dd label,
  .tcgm .item a {
    font-size: 16px;
  }
  .tcgm .item .price b {
    font-size: 40px;
  }
  .tcgm .item .price {
    font-size: 30px;
  }
}
</style>
